import {ChangeDetectionStrategy, Component} from "@angular/core";
import {FUIAbstractLabel} from "../../../labels/abstract-label";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "fui-checkbox-label",
    styleUrls: ["./checkbox-label.component.scss"],
    templateUrl: "./checkbox-label.component.html",
    standalone: false
})
export class FUICheckboxLabelComponent extends FUIAbstractLabel {
}
